import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { ShapeUtils, Vector2, Vector3 } from "three";
import { EMaterialSlot } from "../Meshes/EMaterialSlot";
import { SubMesh } from "../Meshes/SubMesh";
import { SubMeshCollection } from "../Meshes/SubMeshCollection";

export class PlankGenerator {
    private _bottomOutline: Vector3[];
    private _thickness: LengthValue;

    constructor(bottomOutline: Vector3[], thickness: LengthValue) {
        this._bottomOutline = bottomOutline;
        this._thickness = thickness;
    }

    public build(verticalMeshesMaterialSlot: EMaterialSlot = EMaterialSlot.Inside, frontMaterialSlot: EMaterialSlot | null = null, overrideAllSlot: EMaterialSlot | null = null): SubMeshCollection {
        const collection: SubMeshCollection = new SubMeshCollection();

        const shapePoints = this._bottomOutline.map(v => new Vector2(v.x, v.z))

        const triangles = ShapeUtils.triangulateShape(shapePoints, []);

        const indices: number[] = [];
        triangles.forEach(i => {
            indices.push(i[0], i[1], i[2]);
        });

        const vertices1 = shapePoints.map(v => new Vector3(v.x, 0, v.y));
        const vertices2 = shapePoints.map(v => new Vector3(v.x, this._thickness.meter, v.y));

        collection.add(new SubMesh(vertices1, indices).flip(), overrideAllSlot !== null ? overrideAllSlot : EMaterialSlot.Inside);
        collection.add(new SubMesh(vertices2, indices), overrideAllSlot !== null ? overrideAllSlot : EMaterialSlot.Inside);

        // All edges of the insideOutline are extruded to the bottom, with a face towards the oustide
        // (to create the outside thickness)
        // They are behind the side planks, so they only appear when a front face is visible

        for (let i = 0; i < this._bottomOutline.length; i++) {
            const v1 = this._bottomOutline[i === 0 ? this._bottomOutline.length - 1 : i - 1];
            const v2 = this._bottomOutline[i];

            collection.add(SubMesh.polygon(
                v1,
                new Vector3(v1.x, this._thickness.meter, v1.z),
                new Vector3(v2.x, this._thickness.meter, v2.z),
                v2),
                overrideAllSlot !== null ? overrideAllSlot : (frontMaterialSlot !== null ? frontMaterialSlot : verticalMeshesMaterialSlot));

            frontMaterialSlot = null;
        }

        return collection;
    }
}
